export default "__VITE_ASSET__BqHlIMW___"